/* eslint-disable react/jsx-no-target-blank */
/* eslint-env browser */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

class BoxComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    const { open } = this.state;
    this.setState({
      open: !open,
    });
  }

  render() {
    const { open } = this.state;
    const { education } = this.props;
    let classNames = 'column large-4 medium-4 small-12 evu-edu';
    if (open) {
      classNames += ' open';
    }

    const type = (() => {
      if (education.Type !== null) {
        return (
          <li>
            <span>
              {'Kursustype: '}
            </span>
            {education.Type}
          </li>
        );
      }
      return null;
    })();

    const subject = (() => {
      if (education.Subject !== null) {
        return (
          <li>
            <span>
              {'Emner: '}
            </span>
            {education.Subject}
          </li>
        );
      }
      return null;
    })();

    const provider = (() => {
      if (education.Provider !== null) {
        return (
          <li>
            <span>
              {'Udbyder: '}
            </span>
            {education.Provider}
          </li>
        );
      }
      return null;
    })();

    const location = (() => {
      if (education.Location !== null) {
        return (
          <li>
            <span>
              {'Sted: '}
            </span>
            {education.Location}
          </li>
        );
      }
      return null;
    })();

    const occurence = (() => {
      if (education.Occurence !== null) {
        return (
          <li>
            <span>
              {'Starttidspunkt: '}
            </span>
            {education.Occurence}
          </li>
        );
      }
      return null;
    })();

    return (
      <div className={classNames}>
        <div>
          <span />
          <h2>
            <a href={education.Url} target="_blank">
              {education.Name}
            </a>
          </h2>
          <div dangerouslySetInnerHTML={{ __html: `<p>${education.Description}</p>` }} />
          <ul>
            {type}
            {subject}
            {provider}
            {location}
            {occurence}
          </ul>
          <p>
            <a href={education.Url} target="_blank">
              Læs mere
            </a>
          </p>
          <span>
            <button type="button" onClick={this.handleToggle} />
          </span>
          <span />
        </div>
      </div>
    );
  }
}

BoxComponent.propTypes = {
  education: PropTypes.shape({
    Occurence: PropTypes.string.isRequired,
    Location: PropTypes.string.isRequired,
    Type: PropTypes.string.isRequired,
    Subject: PropTypes.string.isRequired,
    Provider: PropTypes.string.isRequired,
    Url: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
    Description: PropTypes.string.isRequired,
  }).isRequired,
};

BoxComponent.displayName = 'BoxComponent';
export default BoxComponent;
